import { DSText } from '@engenharia/ds-react';
import { useTranslation } from 'react-i18next';
import {
  ContainerRadio,
  Counter,
  CounterLabel,
  CounterOption,
  CounterRadio,
  FormInput,
} from './styles';
import { Heading } from '../../Onboarding/styles';

export default function ProfilesCard({ profiles, setProfiles }) {
  const { t } = useTranslation();

  const optionProfilesQuantity = [
    { key: 'one_profile', quantityProfile: 1 },
    { key: 'five_profiles', quantityProfile: 5 },
    { key: 'nine_profiles', quantityProfile: 9 },
    { key: 'ten_more_profiles', quantityProfile: 10 },
  ];

  return (
    <>
      <Heading component="h2" variant="h4">
        {t('settings.steps.profiles.brandsHeading')}
      </Heading>
      <FormInput>
        {optionProfilesQuantity.map((option) => (
          <Counter
            key={option.key}
            onClick={() => {
              setProfiles(option.quantityProfile);
            }}
            isChecked={option.quantityProfile === profiles}
          >
            <ContainerRadio>
              <CounterRadio isChecked={option.quantityProfile === profiles} />
              <CounterOption>{t(`settings.steps.profiles.options.${option.key}`)}</CounterOption>
            </ContainerRadio>
            <CounterLabel>
              <DSText variant="body2">
                {option.quantityProfile === 1
                  ? t('settings.steps.profiles.single.label')
                  : t('settings.steps.profiles.several.label')}
              </DSText>
            </CounterLabel>
          </Counter>
        ))}
      </FormInput>
    </>
  );
}
